// Por onde o cliente respondeu o orçamento.
//
// O cliente nem sempre baixa o app para aprovar: responde no WhatsApp, liga ou
// fala no balcão, e quem registra a resposta é a oficina (`PATCH
// /quotes/:id`). `app` é o único canal que o próprio cliente grava (`PATCH
// /b2c/quotes/:id`) — a rota da oficina não aceita `app`, senão uma resposta
// registrada pelo mecânico passaria por aprovação do cliente no aplicativo.
//
// O canal é a prova numa discussão ("eu não aprovei isso"): junto com quem
// registrou (`quotes.responded_by`), diz de onde veio o sim.
export const QUOTE_RESPONSE_CHANNELS = ['app', 'whatsapp', 'phone', 'in_person', 'other'] as const;
export type QuoteResponseChannel = (typeof QUOTE_RESPONSE_CHANNELS)[number];

/** Canais que a OFICINA pode informar — todos menos o app do cliente. */
export const WORKSHOP_QUOTE_RESPONSE_CHANNELS = ['whatsapp', 'phone', 'in_person', 'other'] as const;
export type WorkshopQuoteResponseChannel = (typeof WORKSHOP_QUOTE_RESPONSE_CHANNELS)[number];

export const QUOTE_RESPONSE_CHANNEL_LABELS: Record<QuoteResponseChannel, string> = {
  app: 'Pelo app',
  whatsapp: 'WhatsApp',
  phone: 'Ligação',
  in_person: 'Pessoalmente',
  other: 'Outro',
};

/**
 * Linha de rodapé da resposta: "Informado por Ana · WhatsApp". Nulo quando o
 * próprio cliente respondeu pelo app, ou em orçamento respondido antes de o
 * canal existir — nesses dois casos a tela mostra só o status.
 */
export function quoteResponseRecordedLine(
  channel: QuoteResponseChannel | null | undefined,
  recordedByName: string | null | undefined,
): string | null {
  if (!channel || channel === 'app') return null;
  const label = QUOTE_RESPONSE_CHANNEL_LABELS[channel];
  return recordedByName ? `Informado por ${recordedByName} · ${label}` : `Informado pela oficina · ${label}`;
}
